import type { IconSvgObject } from './types';

const ShampooIcon: IconSvgObject = [
  ["path", { d: "M17 21V13C17 10.2386 14.7614 8 12 8C9.23858 8 7 10.2386 7 13V21C7 21.5523 7.44772 22 8 22H16C16.5523 22 17 21.5523 17 21Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10 8V6C10 5.44772 10.4477 5 11 5H13C13.5523 5 14 5.44772 14 6V8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 5V2M12 2H9M12 2H15.5L17 3.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M7 13H16.5238", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default ShampooIcon;
